import { serverTimestamp } from "firebase/firestore";
import { normalizeSupportProfile } from "../../../utils/supportProfile";
import { normalizeCareContext } from "../../../utils/careContext";
import { normalizeCareFocusSelection, splitCareFocusSelection } from "../../../constants/childProfileOptions";
import { deriveAgeGroupFromDateOfBirth, deriveAgeLabelFromDateOfBirth } from "../../../utils/profileAge";

export const buildNewChildProfilePayload = ({
  name = "",
  age = "",
  dateOfBirth = "",
  selectedConditions = [],
  careContext = {},
  supportProfile = {},
  careOwnerId = "",
  profileColorKey = "",
} = {}) => {
  const normalizedCareFocus = normalizeCareFocusSelection(selectedConditions);
  const { additionalSupports } = splitCareFocusSelection(normalizedCareFocus);
  const conditionCodes = normalizedCareFocus.map((item) => item.code);
  const derivedAge = deriveAgeLabelFromDateOfBirth(dateOfBirth) || age;
  const derivedAgeGroup = deriveAgeGroupFromDateOfBirth(dateOfBirth) || careContext.ageGroup;

  return {
    name,
    age: derivedAge,
    dateOfBirth,
    photoURL: "",
    profileColorKey,
    users: {
      care_owner: careOwnerId,
      care_partners: [],
      caregivers: [],
      therapists: [],
      members: [careOwnerId],
    },
    status: "active",
    createdBy: careOwnerId,
    createdAt: serverTimestamp(),
    updatedBy: careOwnerId,
    updatedAt: serverTimestamp(),
    settings: {
      allow_therapist_family_logs: false,
    },
    conditions: normalizedCareFocus,
    conditionCodes,
    careContext: normalizeCareContext({
      ...careContext,
      ageGroup: derivedAgeGroup,
      careFocus: normalizedCareFocus,
      additionalSupports,
    }),
    medicalProfile: {
      foodAllergies: [],
      dietaryRestrictions: [],
      sensoryIssues: [],
      behavioralTriggers: [],
      supplements: [],
      communicationNeeds: [],
    },
    supportProfile: normalizeSupportProfile(supportProfile),
    profileSetup: {
      stage: "intake",
      completed: false,
    },
  };
};
